import MapService from "@/service/MapService";
import MapObjectStatusService from "@/service/MapObjectStatusService";
import MapDataStream from "../MapDataStream";

export default class MapObjectStatusDataStream extends MapDataStream {
    constructor(id, publisherId, mapId, locale, availableOnMap = true) {
        super(id);

        const mapService = new MapService();
        const mapObjectStatusService = new MapObjectStatusService(locale);

        mapObjectStatusService.loadMapObjectStatusTemplates(publisherId, mapId).then((mapObjectStatusTemplates) => {
            mapService.listeningToMapObjectStatusForMap(publisherId, mapId, availableOnMap, (mapObjectStatusList) => {
                this.mapObjectStatusTemplates = mapObjectStatusTemplates;
                this.mapObjectStatusList = mapObjectStatusList;

                this._update();
            });
            this._update();
        });
    }

    addOrUpdateMapObjectStatus(mapObjectStatus) {
        if (mapObjectStatus) {
            const foundMapObjectStatus = this._findMapObjectStatus(mapObjectStatus.id);
            if (foundMapObjectStatus) {
                foundMapObjectStatus.updateFrom(mapObjectStatus);
            } else {
                this.mapObjectStatusList.push(mapObjectStatus);
            }
            this._update(true);
        }
    }

    removeMapObjectStatus(mapObjectStatusId) {
        if (mapObjectStatusId) {
            const foundMapObjectStatus = this._findMapObjectStatus(mapObjectStatusId);
            if (foundMapObjectStatus) {
                this.mapObjectStatusList.splice(this.mapObjectStatusList.indexOf(foundMapObjectStatus), 1);
                this._update(true);
            }
        }
    }

    _update(forceImmediate = false) {
        var timerToUse = null;
        if (forceImmediate) {
            timerToUse = this.immediateUpdateTimer;
        } else {
            timerToUse = this.updateTimer;
        }

        if (timerToUse) {
            clearTimeout(timerToUse);
        }

        const timerFunction = () => {
            for (var subscriber of this.subscribers) {
                subscriber.next({
                    mapObjectStatusTemplates: this.mapObjectStatusTemplates,
                    mapObjectStatusList: this.mapObjectStatusList
                });
            }
        };

        if (forceImmediate) {
            this.immediateUpdateTimer = setTimeout(timerFunction, 100);
        } else {
            this.updateTimer = setTimeout(timerFunction, 100);
        }
    }

    _findMapObjectStatus(statusId) {
        for (var mapObjectStatus of this.mapObjectStatusList) {
            if (mapObjectStatus.id === statusId) {
                return mapObjectStatus;
            }
        }
    }
}
